import { render, staticRenderFns } from "./EmdContainer.vue?vue&type=template&id=677b267c&scoped=true&"
import script from "./EmdContainer.vue?vue&type=script&lang=js&"
export * from "./EmdContainer.vue?vue&type=script&lang=js&"
import style0 from "./EmdContainer.vue?vue&type=style&index=0&id=677b267c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b267c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677b267c')) {
      api.createRecord('677b267c', component.options)
    } else {
      api.reload('677b267c', component.options)
    }
    module.hot.accept("./EmdContainer.vue?vue&type=template&id=677b267c&scoped=true&", function () {
      api.rerender('677b267c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/molecules/EmdContainer.vue"
export default component.exports